import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CountriesService } from '@core/services/countries.service';
import { ProcessingTypes } from '@core/typings/payment.typing';
import { AllowedLocation } from '@core/typings/program.typing';
import { AddOrgUI } from '@core/typings/ui/add-org.typing';
import { LookupFormGroup } from '@features/add-organization/add-org-modal/add-org-modal.component';
import { AddOrganizationService } from '@features/add-organization/add-organization.service';
import { TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'gc-add-org-id-lookup',
    templateUrl: './add-org-id-lookup.component.html',
    styleUrls: ['./add-org-id-lookup.component.scss'],
    standalone: false
})
export class AddOrgIdLookupComponent implements OnInit, OnDestroy {
  @Input() lookupFormGroup: TypeSafeFormGroup<LookupFormGroup>;
  @Input() disableCountrySelect: boolean;
  @Input() processorType: ProcessingTypes;
  @Input() allowedOrgLocations: AllowedLocation[];

  private sub = new Subscription();
  countrySelects = this.countriesService.countrySelects;
  countryIdToCountryMap = this.countriesService.countryIdToCountryMap;

  constructor (
    private addOrgService: AddOrganizationService,
    private countriesService: CountriesService
  ) { }

  ngOnInit () {
    const allowedCountryCodes = (this.allowedOrgLocations || []).map((location) => {
      return this.countryIdToCountryMap[location.countryId].countryCode;
    });
    if (allowedCountryCodes.length > 0) {
      this.countrySelects = this.countriesService.countrySelects.filter((country) => {
        return allowedCountryCodes.includes(country.value);
      });
    }
    this.addOrgService.setValidation(this.lookupFormGroup.valid);
    this.sub.add(this.lookupFormGroup.statusChanges.subscribe(() => {
      this.addOrgService.setValidation(this.lookupFormGroup.valid);
    }));
  }

  updateAddOrg <K extends keyof AddOrgUI.AddOrgPayload> (
    attr: K,
    data: AddOrgUI.AddOrgPayload[K]
  ) {
    this.addOrgService.setAddOrgAttr(attr, data);
  }

  ngOnDestroy () {
    this.sub.unsubscribe();
  }
}
